import React, { useEffect, useState } from "react";
import {
	// useHistory,
	useNavigate,
	useParams,
} from "react-router-dom";

// COMPS
import { CircularProgress } from "@material-ui/core";
// STYLES
import { PageWrapper } from "./EmailVerification.style";
import { ReactComponent as HeaderLogo } from "../../../Assets/Images/LandingPage/subjects-master-logo.svg";

import { Api, URL_LOGIN } from "Helpers";

function ForgotPassword(props) {
	let [isLoading, setIsLoading] = useState(true),
		[isSuccess, setSuccess] = useState(false);

	// ROUTER
	// let history = useHistory();
	const navigate = useNavigate();
	let { token } = useParams();

	useEffect(registerAccount, []);

	function registerAccount() {
		let data = new FormData();
		data.append("emailVerificationToken", token);

		new Api().post("user/verificationToken ", { data }).then((response) => {
			setIsLoading(false);
			setSuccess(true);

			setTimeout(() => {
				navigate(URL_LOGIN);
			}, 1000);
		});
	}

	return (
		<PageWrapper>
			<div className="PageWrapper">
				<div className="verification-container">
					<div className="verification-box">
						<div className="emailverification-logo">
							<HeaderLogo />
						</div>

						<div className={`icon-wrapper ${isSuccess ? "success" : ""}`}>
							{isSuccess ? "✔" : "⏳"}
						</div>
						<div className="content">
							<h2 className="title">{isSuccess ? "Account Activated!" : "Just a Second..."}</h2>
							<p className="message">
								{isSuccess
									? "Your account has been successfully activated."
									: "We are preparing your shiny new account."}
							</p>
							{isLoading && (
								<div className="progress">
									<CircularProgress color="secondary" size={30} />
								</div>
							)}
						</div>
					</div>
				</div>
			</div>

		</PageWrapper>
	);
}

export default ForgotPassword;
